import { TableBody, TableCell, TableRow } from "@mui/material";
import { VersionActionCell } from "../VersionActionCell";
import { transformDate } from "../../helpers";
import { VersionRefCell } from "../VersionRefCell";
import { generateId } from "../../../../shared/utils/generateId";
import styles from "./styles.module.css";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";

interface Props<T extends StorageObjectValue> {
  versions: StorageObjectVersion<T>[];
  onOk: (id: string) => void;
}

export const VersionsTableBody = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  return (
    <TableBody>
      {props.versions.map((version) => (
        <TableRow
          key={`${version.id}-${version.version_id}-${version.version_name}`}
          className={styles["table-body-row"]}
        >
          <TableCell>
            {transformDate(version?.version_date as string, "ru-RU")}
          </TableCell>
          <TableCell>{version.version_name}</TableCell>
          <VersionRefCell versionRef={version.ref!} id={version?.version_id!} />
          <VersionActionCell
            id={version?.version_id as string}
            name={version?.version_name as string}
            onOk={() => props.onOk(version?.version_id as string)}
          />
        </TableRow>
      ))}
    </TableBody>
  );
};
